module.exports = __webpack_public_path__ + "img/MOBILE-VTA-VALORACION-MODIFICAR01.42b628f6.png";